import { $ } from "../third-party-imports";

export function updatePostalCodeOnHeader()
{
    if (localStorage.getItem('searchTerm') !== undefined)
    {
        $(".locateForm").find('input').val(localStorage.getItem('searchTerm'));
    }
}
